import { takeLatest } from 'redux-saga';
import { LOAD_BOOK_TRIP } from 'app/constants';
import loadBookTrip from './loadBookTrip';

export default function* watchLoadBookTrip() {
  yield takeLatest(LOAD_BOOK_TRIP, loadBookTrip);
}
